import { WeightTypes } from '../localization'

export enum DosageType {
  MG_KG = 'mg / kg',
  MG_LB = 'mg / lb',
  MCG_KG = 'mcg / kg',
  ML_KG = 'mL / kg',
  UNITS_KG = 'units / kg',

  MG_M2 = 'mg / m2',
  MCG_M2 = 'mcg / m2',
}

export const SquareCalcTypeDosageUnits = new Set([
  DosageType.MG_M2,
  DosageType.MCG_M2,
])

export const WeightCalcTypeDosageUnits = new Set([
  DosageType.MG_KG,
  DosageType.MG_LB,
  DosageType.MCG_KG,
  DosageType.ML_KG,
  DosageType.UNITS_KG,
])

export const WeightCalcTypeToWeightUnitMap: Partial<
Record<DosageType, WeightTypes>
> = {
  [DosageType.MG_KG]: WeightTypes.KG,
  [DosageType.MG_LB]: WeightTypes.LBS,
  [DosageType.MCG_KG]: WeightTypes.KG,
  [DosageType.ML_KG]: WeightTypes.KG,
  [DosageType.UNITS_KG]: WeightTypes.KG,
}
